module.exports = __webpack_public_path__ + "static/review-2-a5d77cbeac8685e2ea33eeb31e88b707.jpg";